var React = require('react');

function IconKey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M721.4 770.4l107.7 107.7c19.7 19.7 51.6 19.8 71.5-.2 19.8-19.8 19.7-52 .2-71.5L553.2 458.8c99-116.1 116.8-265.6 36.8-345.5-85.8-85.8-251.6-59-370.4 59.7S74.1 457.6 159.9 543.4c73.9 73.9 207.3 64.3 318.7-15.8l195 195-47.8 47.8-71.7-71.7-71.7 71.7 191.2 191.2 71.7-71.7-71.7-71.7 47.8-47.8zM477.2 324.3c-23.5 23.5-61.5 23.5-85 0s-23.5-61.5 0-85 61.5-23.5 85 0 23.4 61.6 0 85zM371 430.5c-23.5 23.5-61.5 23.5-85 0s-23.5-61.5 0-85 61.5-23.5 85 0c23.4 23.5 23.4 61.6 0 85z"}));
}

IconKey.displayName = "IconKey";

IconKey.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconKey;

IconKey.default = IconKey;
